module.exports = __webpack_public_path__ + "img/blog-img-2.ad260b9f.jpg";